<template>
    <div class="table-container">
        <div class="py-2 px-3">
            <b-button variant="success" @click="onRefresh()">Обновить</b-button>
        </div>

        <b-table
            id="my-table-body"
            sticky-header
            bordered
            head-variant="light"
            :items="journal"
            :fields="fieldJ"
            :table-variant="light"
            :per-page="perPage"
            :current-page="currentPage"
        >
            <template #cell(username)="row">
                <div align="center" class="code_text">{{ row.item.username }}</div>
            </template>
            <template #cell(file_path)="row">
                <div align="center" class="code_text">{{ row.item.file_path }}</div>
            </template>
            <template #cell(file_name)="row">
                <div align="center" class="code_text">{{ row.item.file_name }}</div>
            </template>
            <template #cell(date_upload)="row">
                <div align="left" class="code_text">{{ row.item.date_upload }}</div>
            </template>
            <template #cell(date_report)="row">
                <div align="center" class="code_text">{{ row.item.date_report }}</div>
            </template>
            <template #cell(description)="row">
                <div align="center" class="code_text">{{ row.item.description }}</div>
            </template>
            <template #cell(cnt)="row">
                <div align="center" class="code_text">{{ row.item.cnt }}</div>
            </template>
            <template #cell(error)="row">
                <div align="center" class="code_text">{{ row.item.error }}</div>
            </template>
        </b-table>

        <div class="d-flex align-items-center justify-content-between px-3 py-2">
            <div class="d-flex align-items-center gap-2">
                <span class="text-muted small">Строк на странице:</span>
                <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width: 80px"
                    @change="currentPage = 1"
                />
            </div>

            <b-pagination
                v-model="currentPage"
                :total-rows="journal.length"
                :per-page="perPage"
                aria-controls="my-table-body"
                size="sm"
                first-number
                last-number
                class="mb-0"
            />

            <span class="text-muted small">
                Всего записей: {{ journal.length }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JournalTable',
    data() {
        return {
            light: 'light',
            journal: [],
            currentPage: 1,
            perPage: 20,
            perPageOptions: [10, 20, 50, 100],
            fieldJ: [
                {key: 'username',    label: 'Пользователь',               sortable: false},
                {key: 'file_path',   label: 'Загружаемый файл',           sortable: false},
                {key: 'file_name',   label: 'Наименование отчета',        sortable: false},
                {key: 'date_upload', label: 'Дата загрузки',              sortable: false},
                {key: 'date_report', label: 'Дата отчета',                sortable: false},
                {key: 'description', label: 'Статус загрузки',            sortable: false},
                {key: 'cnt',         label: 'Кол-во загруженных записей', sortable: false},
                {key: 'error',       label: 'Ошибка',                     sortable: false}
            ]
        };
    },
    mounted() {
        this.loadJournal();
    },
    methods: {
        async loadJournal() {
            try {
                const response = await fetch('/api-py/journal');
                this.journal = await response.json();
                this.currentPage = 1; // сбрасываем страницу при перезагрузке
                this.journal.forEach(value => {
                    if (value.date_report) {
                        value.date_report = value.date_report.toString().substring(0, 10);
                    } else {
                        console.debug('value', value);
                    }
                });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса loadJournal()', error.toString());
            }
        },
        onRefresh() {
            this.loadJournal();
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }
    }
};
</script>